import { useEffect, useState } from "react";
import { fetchCandidateData } from "../services/api";

const initialState = { data: null, loading: false, error: null };

export const useCandidateData = (lang) => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (!lang) {
      setState({
        data: null,
        loading: false,
        error: "Error! Please provide language parameter in the url.",
      });
      return;
    }

    setState({ data: null, loading: true, error: null });

    fetchCandidateData(lang)
      .then((data) =>
        setState({
          data,
          loading: false,
          error: null,
        })
      )
      .catch((error) => {
        console.error(error);
        setState({
          data: null,
          loading: false,
          error: "Error fetching Candidates data 😔 Please refresh.",
        });
      });
  }, [lang]);

  return state;
};
